import { styled } from '@mui/material';
import React from 'react';

const StyledSVG = styled('svg')({
  width: '100%',
  height: 'auto',
  maxWidth: '20px',
  fill: 'white',
});

const Windows = () => {
  return (
    <StyledSVG xmlns="http://www.w3.org/2000/svg" width="164.11" height="200.01" viewBox="0 0 164.11 200.01">
      <path d="m82.21,47C80.21,22,100.21,2,123.21,0c2.9,29-25,49.9-41,47m54.9,144.8c-11,11-22,9-33,4-12-5-23-5-35,0-16,7-24,5-33-4C-17.79,135.9-9.89,50.9,50.11,48c15,1,25,8,33,9,13-3,25-10,39-9,16,1,29,8,37,20-34,21-26,65.9,5,78.9-6,15.9-14,32.9-27,44.9h0Z" />
    </StyledSVG>
  );
};

export default Windows;
